export enum FinancialUnlockBlockedClientEnum {
    NO_SITUATION = 'Nenhuma situação',
    AFTER_PAYING_ALL_INSTALLMENT = 'Após pagar todas as contas',
    AFTER_PAYING_OF_OVERDUE_INSTALLMENTS = 'Após pagar todas as contas atrasadas'
}

export type FinancialUnlockBlockedClient = 'NO_SITUATION' | 'AFTER_PAYING_ALL_INSTALLMENT' | 'AFTER_PAYING_OF_OVERDUE_INSTALLMENTS';
